export const getSegementationGroups = ({ routes = [] }) => {
    const routeWithSegmentation = (routes ?? []).find((route) => route.routeProps?.segmentation?.groups?.length);
    const groups = routeWithSegmentation?.routeProps?.segmentation?.groups ?? [];
    return groups.reduce(
        (acc, curr) => ({
            ...acc,
            [curr]: true,
        }),
        {},
    );
};

export const glassboxIdentify = (uuid) => {
    if (window._detector?.triggerCustomEvent) {
        window._detector.triggerCustomEvent('userID', uuid);
    }
};

export const glassboxSegmentation = (payload) => {
    if (window._detector?.triggerCustomEventMap) {
        window._detector.triggerCustomEventMap('segmentation', getSegementationGroups(payload));
    }
};
